<script>
import { h } from 'vue';
import { withBreaks } from './mergeFieldSamples';

// BodySanitizer's allowlist, applied again on the way out: a stored body is
// shown in the app's own origin, so nothing but these tags and their text may
// reach the page — no attributes, no other elements. The one exception is a
// block's link, drawn by TemplateRenderer::renderPortal: it keeps its href
// only while that is a path on this site.
const ALLOWED = new Set(['b', 'strong', 'i', 'em', 'u', 'p', 'ol', 'ul', 'li', 'br']);
const DROPPED = new Set(['script', 'style']);
const SAME_SITE_PATH = /^\/(?![/\\])/;

const toVNodes = (node) => [...node.childNodes].flatMap((child) => {
  if (child.nodeType === Node.TEXT_NODE) return child.textContent;
  if (child.nodeType !== Node.ELEMENT_NODE) return [];

  const tag = child.tagName.toLowerCase();
  if (DROPPED.has(tag)) return [];
  if (tag === 'a') return link(child);
  if (!ALLOWED.has(tag)) return toVNodes(child);

  return h(tag, toVNodes(child));
});

const link = (a) => {
  const href = a.getAttribute('href') ?? '';

  return SAME_SITE_PATH.test(href) ? h('a', { href }, toVNodes(a)) : toVNodes(a);
};

export default {
  name: 'SafeRichText',
  props: { html: { type: String, default: '' } },
  setup(props) {
    return () => {
      // DOMParser documents are inert: nothing in them runs or loads.
      const body = new DOMParser().parseFromString(withBreaks(props.html), 'text/html').body;

      return h('div', toVNodes(body));
    };
  },
};
</script>
